<template>
  <div class="daily-checkin-window">
    <Line />
    <div class="checkin">
      <div class="checkin-number">{{ userStore.streakDays }}</div>
      <div class="checkin-text">Day Check-in</div>
      <div class="checkin-hint">
        Keep Checking in every day<br />
        for more rewards
      </div>
    </div>
    <Confetti ref="confetti" class="confetti" />
    <Transition name="fade-in">
      <div v-if="showRewards" class="checkin-reward">
        <LeeaCard>
          <template #title>Daily Rewards</template>
          <template #description
            >Come back tomorrow for another check-in.<br />Skipping a day resets your
            streak.</template
          >
          <template #content>
            <Rewards v-if="userStore.reward" :value="userStore.reward" />
          </template>
        </LeeaCard>
        <LeeaBtn @click="emit('close')">Continue</LeeaBtn>
      </div>
    </Transition>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue'
import Line from '@/components/Line.vue'
import LeeaBtn from '@/components/LeeaBtn.vue'
import LeeaCard from '@/components/LeeaCard.vue'
import Rewards from '@/components/Rewards.vue'
import Confetti from './Confetti.vue'
import { useUserStore } from '@/stores/user'

const emit = defineEmits(['close'])
const confetti = ref()
const showRewards = ref(false)

onMounted(() => {
  confetti.value.explode()
  window.setTimeout(() => {
    showRewards.value = true
  }, 2500)
})
const userStore = useUserStore()
</script>
<style lang="scss" scoped>
.confetti {
  position: fixed;
  top: 0;
  left: 0;
}

.daily-checkin-window {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: url('@/assets/bg-shapes.png'), linear-gradient(#74a3ff, #256fff);
  background-size: cover;
  z-index: 10;

  .checkin,
  .checkin-reward {
    width: 100vw;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 60px 20px 80px 20px;
    box-sizing: border-box;
    color: white;
  }

  .checkin-reward {
    justify-content: space-between;
    background:
      url('@/assets/lines.png') no-repeat,
      white;
    background-size: contain;
    background-position: bottom 80px center;
  }

  .checkin {
    .checkin-number {
      font-family: 'Forma DJR Display';
      font-weight: 700;
      letter-spacing: 0.02em;
      font-size: 98px;
      height: 108px;
    }

    .checkin-text {
      font-family: 'Forma DJR Display';
      font-weight: 700;
      letter-spacing: 0.03em;
      font-size: 36px;
      margin-bottom: 20px;
    }
  }

  .line {
    width: 100%;
    height: 100%;
    transform: scale(2.5);
    stroke-dasharray: 4000;
    stroke-dashoffset: 4000;
    animation:
      dash 1s ease-in forwards,
      wide 0.3s ease-in 2s forwards;
    stroke-width: 30px;
    stroke: white;
    stroke-linecap: round;
  }

  @keyframes dash {
    0% {
      stroke-dashoffset: 4000;
    }

    100% {
      stroke-dashoffset: 0;
    }
  }

  @keyframes wide {
    0% {
      stroke-width: 30px;
    }

    100% {
      stroke-width: 500px;
    }
  }
}
</style>
